export default function(location: Location) {
  const path = `${location.origin}/setting`
  const regx = new RegExp(path);
  const currentPath = location.origin + location.pathname
  return regx.test(currentPath);
  // return /setting/.test(location.href);
}
